import { FormattedMessage } from 'dibs-react-intl';

export const sbSharedRefineMenuMessages = {
    to: <FormattedMessage id="sb.SbSharedAppliedFiltersItem.inputRange.to" defaultMessage="to" />,
    TO: <FormattedMessage id="sb.SbSharedAppliedFiltersItem.inputRange.TO" defaultMessage="TO" />,
    shippingFree: (
        <FormattedMessage
            id="sb.SbSharedAppliedFiltersItem.freeShipping"
            defaultMessage="Free Shipping"
        />
    ),
    shippingOptions: (
        <FormattedMessage
            id="sb.SbSharedAppliedFiltersItem.shippingOptions"
            defaultMessage="Shipping Options"
        />
    ),
};
